import React from 'react';

const Wellbeing = () => {
  const sample = [
    require('../../assets/images/common/physique.png'),
    require('../../assets/images/common/happy.png'),
    require('../../assets/images/common/emotions.png'),
    require('../../assets/images/common/forth.png'),
  ];

  const cards = [
    {
      title: 'Physique',
      subtitle: 'Benefits of physical exercise and maintaining a healthy physique.',
      bg: 'from-blue-200 to-blue-100',
      img: sample[0],
    },
    {
      title: 'Mental Health',
      subtitle: 'Highlights the significance of mental and emotional health.',
      bg: 'from-amber-200 to-amber-100',
      img: sample[1],
    },
    {
      title: 'Emotional',
      subtitle: 'Taking care of your body and mind.',
      bg: 'from-yellow-200 to-yellow-100',
      img: sample[2],
    },
    {
      title: 'Spiritual',
      subtitle: 'Importance of spiritual well-being.',
      bg: 'from-purple-200 to-purple-100',
      img: sample[3],
    },
  ];

  return (
    <div className='min-h-screen bg-white p-4 sm:p-6 md:p-10'>
      <div className='max-w-md mx-auto'>
        <button className='flex items-center gap-2 text-gray-600 mb-4'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-5 w-5'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M15 19l-7-7 7-7'
            />
          </svg>
          <span className='text-sm'>Back</span>
        </button>

        <h1 className='text-2xl font-semibold text-gray-900 mb-2'>Wellbeing</h1>
        <p className='text-sm text-gray-500 mb-6'>
          We understand the importance of taking care of your body and mind. That's why we have
          created a product that combines the power of nature with modern science to provide you
          with the best possible results.
        </p>

        <div className='space-y-8'>
          {cards.map(({ title, subtitle, bg, img }, index) => (
            <div
              key={index}
              className={`relative rounded-2xl shadow-lg p-4 md:p-6 bg-gradient-to-r ${bg}`}
            >
              <div className='flex items-center'>
                <div className='flex-1'>
                  <h2 classNames='text-lg font-semibold text-gray-900'>{title}</h2>
                  <p className='text-sm text-gray-600 mt-1 w-2/3'>{subtitle}</p>
                </div>
                <img
                  src={img}
                  alt={title}
                  className='absolute right-0 bottom-0 w-48 h-full object-cover'
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Wellbeing;
